import { RowDataTransaction } from "../../components/TransactionPage/types";
import DataDisplayRowI from "../DataDisplayRowI";

/**
 * This class should be intialized with the TransactionTable factory
 */
class CashTransactionRow implements DataDisplayRowI {
    endpoint: string;
    accessData: string;

    constructor() {
        this.endpoint = "/api/admin/cash/read-transaction-history-range"
        this.accessData = "history"
    }

    create(transaction: any): RowDataTransaction {
        const rowDataTransaction: RowDataTransaction = {
            transaction_id: transaction.transaction_id,
            fullname: transaction.fullname,
            coins: transaction.cash,
            type: transaction.type,
            remark: transaction.remarks,
            created_at: transaction.createdAt,
        };
        return rowDataTransaction;
    }
}

let cashTransactionRow: CashTransactionRow | null = null;

export default function getCashTransactionRow(): CashTransactionRow {
    if (cashTransactionRow === null)
        cashTransactionRow = new CashTransactionRow()
    return cashTransactionRow
}